
<textarea 
  class="required-field"
  formControlName="remarks"
  name="remarks"
  id="remarks"
  cols="30"
  rows="5"
  maxlength="255"
  (focusout)="focusOut($event.target.id)"
  [(ngModel)]="textareaValue"
  (ngModelChange)="characterCount = textareaValue.length">
</textarea>
<label>Character Count: {{ characterCount }}</label>
